import Joi from '@hapi/joi'

export const FieldFactoryCheckrollWeightReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Select Operation Entity`,
        "any.required": `Operation Entity required`
    }),
    searchMonth: Joi.string().invalid("").required().label("Search Month").messages({
        "any.required": `Month required`
    })
}